// config.js

// export const API_BASE_URL = 'http://localhost:3000/api';
export const API_BASE_URL = 'https://uakbgt.uludag.edu.tr/api';


export async function checkAuthentication() {
    const token = localStorage.getItem('token');
    // console.log("Token:", token); // Token değerini logla
    if (!token) {
        return false; // Token boşsa false döndür
    }
    
    const pathApi = `${API_BASE_URL}/users/chk`;
    try {
        const response = await fetch(pathApi, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Authentication failed');
            // return false ;
        }

        const data = await response.json(); // await kullanarak sonucu bekleyin
        // console.log("Authentication Data:", data); // Otantikasyon verilerini logla
        return true ; // Yanıt verisinin 'success' özelliğini döndür
    } catch (error) {
        console.error("Error in checkAuthentication:", error);
        return false ;
        
    }
}


